import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacao(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacao/FIND_OPERACAO':
      case '@operacao/UPDATE_OPERACAO':
      case '@operacao/DELETE_OPERACAO':
      case '@operacao/STORE_OPERACAO':
      case '@operacao/OPERACOES_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacao/SUCCESS_REMOVE':
      case '@operacao/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacao/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacoes;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacao/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacao;
        break;
      }

      case '@operacao/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
